import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE005_Request,
  IAPI_PRE005_Response,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 掛金納付期限延長申請参照
// API仕様書_掛金
const httpAPI_PRE005 = async (
  param: IAPI_PRE005_Request
): Promise<IAPI_PRE005_Response> => {
  let res = await http.post(ApiUrl.API_PRE005, {
    ...param,
  });

  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_PRE005, httpAPI_APP016 };
